import "./style.css";
import Swiper, { Pagination } from "swiper";
import gsap from "gsap";

export default class Carousel {
  static selector = ".s-carousel";

  constructor(block) {
    this.block = block;
    this.pagination = parseInt(block.getAttribute("data-pagination"), 10) === 1;
    this.$spanItems = block.querySelectorAll(
      ".swiper-pagination__holder-tap span"
    );
    this.$slides = block.querySelectorAll(".swiper-slide");
    this.$bar = block.querySelector(".swiper-pagination-bar");

    this.canScroll = true;
    this.addWheelListener();
    this.setBarSize();
  }

  addWheelListener() {
    this.block.addEventListener("mousewheel", this.onMouseWheel.bind(this));
    this.$spanItems.forEach(($span, index) => {
      $span.addEventListener("click", () => {
        this.swiper.slideTo(index);
      });
    });

    this.$slides.forEach(($slide) => {
      $slide.addEventListener("click", () => {
        window.location.href = $slide.getAttribute("data-link");
      });
    });
  }

  async onMouseWheel({ deltaX }) {
    if (!this.canScroll) return false;

    if (deltaX > 10) this.swiper.slideNext();
    else if (deltaX < -10) this.swiper.slidePrev();

    if (deltaX > 10 || deltaX < -10) {
      this.canScroll = false;
      await new Promise((resolve) => setTimeout(resolve, 500));
      this.canScroll = true;
    }
  }

  initSwiper() {
    let options = {};
    if (this.pagination)
      options = {
        pagination: { el: ".swiper-pagination", type: "progressbar" },
        modules: [Pagination],
      };

    this.swiper = new Swiper(this.$root, {
      ...options,
      slidesPerView: 1.35,
      spaceBetween: 27,
      breakpoints: {
        768: {
          spaceBetween: 27,
          slidesPerView: 2.35,
        },
        1240: {
          spaceBetween: 24,
          slidesPerView: 4,
        },
      },
    });

    this.swiper.on("slideChange", () => {
      this.onSlideChanged();
    });
  }

  onResize() {
    const w = window.innerWidth;
    const elements = this.block.querySelectorAll(".s-card").length;
    const $paginationHolder = this.block.querySelector(
      ".swiper-pagination__holder"
    );

    $paginationHolder.classList.remove("hide");

    if (w < 768) {
      if (elements.length <= 1) {
        $paginationHolder.classList.add("hide");
      }
    } else if (w >= 768 && w < 1240) {
      if (elements.length <= 2) {
        $paginationHolder.classList.add("hide");
      }
    } else if (elements <= 4) {
      $paginationHolder.classList.add("hide");
    }

    this.setBarSize();
    this.onSlideChanged();
  }

  onSlideChanged() {
    const { activeIndex } = this.swiper;
    const percentage = this.setBarSize();
    gsap.to(this.$bar, { left: `${percentage * activeIndex}%` });
  }

  setBarSize() {
    const w = window.innerWidth;
    const l = this.$slides.length;
    let barPercentage = 0;

    if (w < 768) {
      if (l <= 1) {
        barPercentage = 100;
      } else {
        barPercentage = 100 / l;
      }
    } else if (w >= 768 && w < 1240) {
      if (l <= 2) {
        barPercentage = 100;
      } else {
        barPercentage = 100 / (l - 1);
      }
    } else if (w >= 1240) {
      if (l <= 4) {
        barPercentage = 100;
      } else {
        barPercentage = 100 / (l - 3);
      }
    }

    gsap.set(this.$bar, { width: `${barPercentage}%` });
    return barPercentage;
  }

  onReady() {
    this.$root = this.block.querySelector(".swiper");
    this.initSwiper();
    this.onResize();
  }
}
